import { BsBoxArrowUpRight } from "react-icons/bs";
import { joinClasses } from "@/utils/styling";
import styles from "./ErrorSummaryList.module.css";
import { type ErrorCode } from "@/models/error-codes.ts";

export default function ErrorsSummaryList({
  errorCodes,
  onErrorCodeClick,
}: {
  errorCodes: ErrorCode[];
  onErrorCodeClick: (code: string) => void;
}) {
  return (
    <div className="border overflow-auto">
      {errorCodes.map(({ code, message, count }) => (
        <button
          key={code}
          className={joinClasses(
            "d-flex w-100 p-3 border-bottom border-end cursor-default button-no-styles list-item-clickable"
          )}
          onClick={() => {
            onErrorCodeClick(code);
          }}
        >
          <div className="me-3">
            <span
              className="badge"
              style={{
                backgroundColor: "hsl(7, 74%, 55%)",
                color: "white",
                minWidth: "32px",
                height: "28px",
                borderRadius: "4px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {count}
              <span className="visually-hidden">occurrences</span>
            </span>
          </div>
          <div className="flex-grow-1">
            <div className="fw-bold">{code}</div>
            {message && <div className="pt-2">{message}</div>}
          </div>
          <a
            href="https://www.cde.ca.gov/sp/cd/ci/capsdacchanges.asp"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.externalLink}
            onClick={(e) => e.stopPropagation()}
          >
            <BsBoxArrowUpRight className="fs-4" />
            <span className="visually-hidden">
              External link to documentation for Error Code {code}
            </span>
          </a>
        </button>
      ))}
    </div>
  );
}
